import { useCallback } from 'react';

import type { UsersResponse } from '@rtkwlf/rendall';

import { useGetUsersList } from '@apis/rendall/queries/use-get-users-list/use-get-users-list';

import { createUsersMapAndOptions } from './create-users-map-and-options';

export const useUserMapAndOptions = () => {
  return useGetUsersList({
    select: useCallback(
      ({ data }: UsersResponse) => createUsersMapAndOptions(data),
      [],
    ),
  });
};
